// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RYHN","top":"styles_top__1VG2P","left":"styles_left__3RMy8","description":"styles_description__b9VCl"};